export const HOSTNAME = {
    localhost: 'localhost',
    int: 'admin-user-access.aws.int.test.visma.net',
    stag: 'admin-user-access.stag.visma.net',
    prod: 'admin-user-access.visma.net',
    // The Scarlet domains, served in parallel with the Visma ones (PICP-13, PICP-15). Each is its
    // environment under a second name: same APIs, same Connect client - only the Connect redirects
    // must come back to the host the user started on (see DomainService.getConnectIdentityConfig).
    stagScarlet: 'admin.stag.scarlet-test.app',
    prodScarlet: 'admin.scarlet.app'
}
